import React, { useState } from 'react';
import { toCamelCase } from '@jbhi-fi/utils/src/toCamelCase';
import { getProductCardActionLabel } from '../../ProductCard/utils/getProductCardActionLabel';
import { ActionButton } from '../../ActionButton/ActionButton';
import { CartActionState } from '../../CartProvider/types';
import { NotifyMeModal } from '../../NotifyMeModal/NotifyMeModal';
import { ActionButtonType } from '../../PdpProductProvider/types';
import { getProductStatusLabel } from '../../ProductCard/utils/getProductStatusLabel';
import { styles } from './ProductCompareActions.css';

export type ProductCompareActionsProps = {
  button: string;
  sku: string;
  title: string;
  productId: string;
  variantId: number;
  productTags?: Array<string>;
  onAddToCart: (e: React.SyntheticEvent<Element, Event>, sku?: string, variantId?: number) => Promise<boolean>;
  onNotifyMe?: (e: React.SyntheticEvent<Element, Event>, sku?: string, variantId?: number) => Promise<boolean>;
};

export const ProductCompareActions = ({
  button,
  sku,
  title,
  productId,
  variantId,
  productTags,
  onAddToCart,
  onNotifyMe,
}: ProductCompareActionsProps) => {
  const [cartState, setCartState] = useState<CartActionState>(CartActionState.Default);
  const [isNotifyMeModalOpen, setIsNotifyMeModalOpen] = useState(false);

  const buttonType = toCamelCase(button);
  const isInStoreOnly = productTags?.includes('In Store Only');
  const productStatusLabel = getProductStatusLabel(productTags);

  const handleNotifyMe = (e: any) => {
    e.preventDefault();
    if (onNotifyMe) {
      onNotifyMe(e, sku, variantId);
    }
    setIsNotifyMeModalOpen(!isNotifyMeModalOpen);
  };

  const handleAddToCart = async (e: React.SyntheticEvent) => {
    setCartState(CartActionState.Updating);
    const success = await onAddToCart(e, sku, variantId);
    if (success) {
      setCartState(CartActionState.Complete);
      window.setTimeout(() => setCartState(CartActionState.Default), 2000);
    } else {
      setCartState(CartActionState.Default);
    }
  };

  return buttonType === ActionButtonType.DoNotDisplay ? (
    <div className={styles.productStatusContainer({ isInStoreOnly })}>{productStatusLabel}</div>
  ) : (
    <>
      <div key={sku} className={styles.actionsContainer}>
        <ActionButton
          label={getProductCardActionLabel(buttonType)}
          actionFinishedLabel={'Added!'}
          onClick={e => (buttonType === 'notifyMe' ? handleNotifyMe(e) : handleAddToCart(e))}
          state={cartState}
        />
      </div>
      <NotifyMeModal
        isOpen={isNotifyMeModalOpen}
        productTitle={title}
        productId={productId}
        variantId={variantId}
        onClose={() => setIsNotifyMeModalOpen(false)}
      />
    </>
  );
};
